var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-simple-form-box" }, [
    _c("div", { staticClass: "c-simple-form-box__content" }, [
      _c("form", { attrs: { novalidate: "" } }, [
        _c(
          "div",
          { staticClass: "grid-container" },
          [
            _c("div", { staticClass: "c-simple-form-box__section" }, [
              _vm.headingBlockOne
                ? _c("h2", { staticClass: "c-simple-form-box__heading" }, [
                    _vm._v(_vm._s(_vm.headingBlockOne))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid-x grid-margin-x o-columns__two" },
                [
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-select", {
                        attrs: {
                          name: "title",
                          id: "title",
                          label: _vm.renderText(_vm.titleLabel, "Title"),
                          options: _vm.titleOptions,
                          required: true,
                          validationError: _vm.titleError,
                          validationMessage: _vm.titleValidationMessage
                        },
                        on: {
                          change: function($event) {
                            return _vm.valueChange($event, "title")
                          }
                        },
                        model: {
                          value: _vm.innerTitle,
                          callback: function($$v) {
                            _vm.innerTitle = $$v
                          },
                          expression: "innerTitle"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showOtherTitle
                    ? _c(
                        "div",
                        { staticClass: "cell" },
                        [
                          _vm.showOtherTitle
                            ? _c("form-input", {
                                attrs: {
                                  name: "other-title",
                                  id: "otherTitle",
                                  label: _vm.renderText(
                                    _vm.otherTitleLabel,
                                    "Other title"
                                  ),
                                  required: true,
                                  validationError: _vm.otherTitleError,
                                  validationMessage:
                                    _vm.otherTitleValidationMessage
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.valueChange($event, "otherTitle")
                                  }
                                },
                                model: {
                                  value: _vm.innerOtherTitle,
                                  callback: function($$v) {
                                    _vm.innerOtherTitle = $$v
                                  },
                                  expression: "innerOtherTitle"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "name",
                          id: "firstName",
                          label: _vm.renderText(
                            _vm.firstNameLabel,
                            "First name"
                          ),
                          required: true,
                          validationError: _vm.firstNameError,
                          validationMessage: _vm.firstNameValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "firstName")
                          }
                        },
                        model: {
                          value: _vm.innerFirstName,
                          callback: function($$v) {
                            _vm.innerFirstName = $$v
                          },
                          expression: "innerFirstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "lastName",
                          id: "lastName",
                          label: _vm.renderText(_vm.lastNameLabel, "Last name"),
                          required: true,
                          validationError: _vm.lastNameError,
                          validationMessage: _vm.lastNameValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "lastName")
                          }
                        },
                        model: {
                          value: _vm.innerLastName,
                          callback: function($$v) {
                            _vm.innerLastName = $$v
                          },
                          expression: "innerLastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "email",
                          id: "email",
                          label: _vm.renderText(_vm.emailLabel, "Email"),
                          required: true,
                          validationError: _vm.emailError,
                          validationMessage: _vm.emailValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "email")
                          }
                        },
                        model: {
                          value: _vm.innerEmail,
                          callback: function($$v) {
                            _vm.innerEmail = $$v
                          },
                          expression: "innerEmail"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "extraDetails",
                          id: "extraDetails",
                          label: _vm.renderText(
                            _vm.extraDetailsLabel,
                            "Organisation"
                          ),
                          required: true,
                          validationError: _vm.extraDetailsError,
                          validationMessage: _vm.extraDetailsValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "extraDetails")
                          }
                        },
                        model: {
                          value: _vm.innerExtraDetails,
                          callback: function($$v) {
                            _vm.innerExtraDetails = $$v
                          },
                          expression: "innerExtraDetails"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "number",
                          type: "tel",
                          id: "number",
                          label: _vm.renderText(
                            _vm.numberLabel,
                            "Contact number"
                          ),
                          required: true,
                          validationError: _vm.numberError,
                          validationMessage: _vm.numberValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "number")
                          }
                        },
                        model: {
                          value: _vm.innerNumber,
                          callback: function($$v) {
                            _vm.innerNumber = $$v
                          },
                          expression: "innerNumber"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-simple-form-box__section" }, [
              _vm.headingBlockTwo
                ? _c("h2", { staticClass: "c-simple-form-box__heading" }, [
                    _vm._v(_vm._s(_vm.headingBlockTwo))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid-x grid-margin-x o-columns__two" },
                [
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "first-line-of-address",
                          id: "firstLineOfAddress",
                          label: _vm.renderText(
                            _vm.firstLineOfAddressLabel,
                            "Property name / number"
                          ),
                          required: true,
                          validationError: _vm.firstLineOfAddressError,
                          validationMessage:
                            _vm.firstLineOfAddressValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "firstLineOfAddress")
                          }
                        },
                        model: {
                          value: _vm.innerFirstLineOfAddress,
                          callback: function($$v) {
                            _vm.innerFirstLineOfAddress = $$v
                          },
                          expression: "innerFirstLineOfAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "second-line-of-address",
                          id: "secondLineOfAddress",
                          label: _vm.renderText(
                            _vm.secondLineOfAddressLabel,
                            "Street"
                          ),
                          required: true,
                          validationError: _vm.secondLineOfAddressError,
                          validationMessage:
                            _vm.secondLineOfAddressValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange(
                              $event,
                              "secondLineOfAddress"
                            )
                          }
                        },
                        model: {
                          value: _vm.innerSecondLineOfAddress,
                          callback: function($$v) {
                            _vm.innerSecondLineOfAddress = $$v
                          },
                          expression: "innerSecondLineOfAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "third-line-of-address",
                          id: "thirdLineOfAddress",
                          label: _vm.renderText(
                            _vm.thirdLineOfAddressLabel,
                            "Town / city"
                          ),
                          required: true,
                          validationError: _vm.thirdLineOfAddressError,
                          validationMessage:
                            _vm.thirdLineOfAddressValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "thirdLineOfAddress")
                          }
                        },
                        model: {
                          value: _vm.innerThirdLineOfAddress,
                          callback: function($$v) {
                            _vm.innerThirdLineOfAddress = $$v
                          },
                          expression: "innerThirdLineOfAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell" },
                    [
                      _c("form-input", {
                        attrs: {
                          name: "postcode",
                          id: "postcode",
                          label: _vm.renderText(_vm.postcodeLabel, "Postcode"),
                          required: true,
                          validationError: _vm.postcodeError,
                          validationMessage: _vm.postcodeValidationMessage
                        },
                        on: {
                          input: function($event) {
                            return _vm.valueChange($event, "postcode")
                          }
                        },
                        model: {
                          value: _vm.innerPostcode,
                          callback: function($$v) {
                            _vm.innerPostcode = $$v
                          },
                          expression: "innerPostcode"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("resources-summary", {
              attrs: {
                requestedItems: _vm.requestedItems,
                summaryHeading: _vm.summaryHeading
              },
              on: {
                removeItem: _vm.removeItem,
                updateQuantity: _vm.updateQuantity
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "c-simple-form-box__actions" }, [
              _c(
                "button",
                {
                  staticClass: "c-button c-button--neutral",
                  attrs: { type: "button" },
                  on: { click: _vm.prevStep }
                },
                [_vm._v(_vm._s(_vm.renderText(_vm.backButtonText, "Back")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-button c-button--brand",
                  attrs: { type: "submit" },
                  on: { click: _vm.checkForm }
                },
                [_vm._v(_vm._s(_vm.renderText(_vm.submitButtonText, "Submit")))]
              )
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ba17460", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba17460","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/resources/form/Form.vue
// module id = 572
// module chunks = 0